import React, { useEffect, useRef, useState } from "react";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import PageInfoAndActionBar from "../../../../Layouts/PageInfoAndActionBar";
import AccessTemplateSelection from "../../../../components/BuilderComponents/AccessTemplateSelection";
import NotesAndTags from "../../../../components/BuilderComponents/NotesAndTags";
import MapPreview from "../../../../components/BuilderComponents/Preview/MapPreview";
import RecordviewDesktopPreview from "../../../../components/BuilderComponents/Preview/RecordviewDesktopPreview";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import { useAuth0Context } from "../../../../context/Auth0Context";
import { useAxiosContext } from "../../../../context/AxiosContext";
import DesktopRenderer from "../../DetailsViewRenderer/Desktop/DesktopRenderer";
import RecordsViewEditSection from "./RecordsViewEditSection";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import { useTableContext } from "../../../../context/TableContext";
import { useNavigate } from "react-router-dom";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import Button from "../../../../components/FormComponents/Button";
import { toastError } from "../../../../utils/toastUtils";

const RecordDesktopRenderer = ({
  applicationBlockData,
  handleSaveApplicationBlock,
  handleCloneApplicationBlock,
  isMapBlock = false
}) => {
  const {
    recordsviewLayout,
    setRecordsviewLayout,
    setApplicationBlockData,
    lockData,
    setLockData,
    layout,
    layoutData,
    nestedGridData
  } = useAppBlocksContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const { axiosInstance, handleSuccess } = useAxiosContext();
  const [showNotesModal, setShowNotesModal] = useState(false);
  const { user } = useAuth0Context();
  const [showOwnerModal, setShowOwnerModal] = useState(false);

  const tableRef = useRef({});
  const { getTableTypeData } = useTableContext();
  const navigate = useNavigate();
  const { setSelectedAppBlock } = useAppBlocksContext();
  const [nonSelectedFilter, setNonSelectedFilter] = useState([]);

  const fetchSingleTable = async () => {
    try {
      tableRef.current = {};
      if (!applicationBlockData.config.layout.table_id) return;
      let { tableObject } = await getTableTypeData(
        applicationBlockData.table_type,
        applicationBlockData.config.layout.table_id
      );

      tableRef.current = tableObject;
    } catch (error) {
      toastError(error.message);
      navigate("../");
      setSelectedAppBlock({ id: "", name: "", parentData: "", table_id: "", activity_id: "" });
    }
  };

  const handletoggleLock = async () => {
    try {
      if (lockData && lockData.user_id) {
        if (lockData.user_id !== user.sub) {
          toastError("Unauthorized");
          return;
        }
        const { message } = await axiosInstance.delete(`/app/lock/${applicationBlockData.id}`);
        handleSuccess(message);
        setLockData({});
      } else {
        const userinfo = `${user.first_name} (${user.email})`;
        const lock = {
          type: "recordview",
          user_id: user.sub,
          user_info: userinfo,
          type_id: applicationBlockData.id,
          type_name: applicationBlockData.name
        };
        const { message } = await axiosInstance.post(`/app/lock`, lock);
        handleSuccess(message);
        setLockData(lock);
      }
    } catch (error) {
      console.error("API call failed", error);
    }
  };

  const afterEffectOfFilter = (data) => {
    const colIds = data.columns.map((obj) => obj.id);
    const richFields = returnRichFields(data);
    const richFieldIds = richFields.map((obj) => obj.id);
    const mainArrayKeys = new Set([...colIds, ...richFieldIds]);

    let selectedFilterArray = [];
    data.onscreen_filters.forEach((obj) => {
      if (mainArrayKeys.has(obj.id)) {
        selectedFilterArray.push({ ...obj, ...tableRef.current[obj.id] });
      }
    });

    const nonSelectedFilterArray = data.columns.filter(
      (obj) => !selectedFilterArray.some((selObj) => selObj.id === obj.id) && obj.type !== "custom"
    );

    const nonSelectedRichFields = richFields.filter(
      (field) => !data.onscreen_filters.some((filter) => filter.id === field.id)
    );
    const modifiedNonSelectedFilter = [...nonSelectedFilterArray, ...nonSelectedRichFields];

    let obj = {
      onscreen_filters: selectedFilterArray
    };

    setRecordsviewLayout({ ...data, ...obj });
    setNonSelectedFilter(modifiedNonSelectedFilter);
  };

  const returnRichFields = (data) => {
    const richFields = data.columns.flatMap(({ type, custom_type, layout_config }) => {
      if (type === "custom" && custom_type === "rich_column" && layout_config && Array.isArray(layout_config.layouts)) {
        return layout_config.layouts.flatMap(({ element_config }) =>
          element_config && element_config.type === "field" ? [element_config] : []
        );
      }
      return [];
    });

    return richFields;
  };

  const handleNotesAndTag = (data, keyName) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData[keyName] = data;
    setApplicationBlockData(copyBlockData);
  };

  const handleAccessTemplate = (data) => {
    const newRecordviewLayout = JSON.parse(JSON.stringify(applicationBlockData));
    newRecordviewLayout.access_templates = data;
    setApplicationBlockData(newRecordviewLayout);
    setShowOwnerModal(false);
  };

  const tabData = [
    {
      label: "Table view",
      content: (
        <RenderTableView
          recordsviewLayout={recordsviewLayout}
          isEditOpen={isEditOpen}
          setIsEditOpen={setIsEditOpen}
          isMapBlock={isMapBlock}
        />
      )
    },
    {
      label: "Catalog view",
      content: <RenderCatalogView recordsviewLayout={recordsviewLayout} applicationBlockData={applicationBlockData} />
    }
  ];

  const initialDataFeetching = async () => {
    await fetchSingleTable();
    afterEffectOfFilter(recordsviewLayout);
  };

  useEffect(() => {
    initialDataFeetching();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationBlockData.id]);

  return (
    <div>
      <PageInfoAndActionBar
        pagePath={`Blocks/${isMapBlock ? "Mapsview" : "Recordsview"}/${applicationBlockData?.name}`}
        toggleLock={handletoggleLock}
        clonePage={handleCloneApplicationBlock}
        savePage={handleSaveApplicationBlock}
        currentConfig={[recordsviewLayout, layout, layoutData.current, nestedGridData.current, applicationBlockData]}
        pageName="applicationblock"
        notesPage={() => setShowNotesModal(!showNotesModal)}
        isLocked={lockData?.user_id || null}
        saveOwner={() => setShowOwnerModal(!showOwnerModal)}
      />

      <div className="recordView_main_page">
        {!isMapBlock && <BuilderTabs tabs={tabData} containerClass={"float_tabs"} />}
        {isMapBlock && (
          <RenderMapPreview
            recordsviewLayout={recordsviewLayout}
            isEditOpen={isEditOpen}
            setIsEditOpen={setIsEditOpen}
            // isEditable={isEditable}
            isMapBlock={isMapBlock}
          />
        )}

        <BuilderModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} modalName="Notes and Tags">
          <NotesAndTags
            notesValue={applicationBlockData.description || ""}
            tagValue={applicationBlockData.info_tag || []}
            onChange={handleNotesAndTag}
          />
        </BuilderModal>
        <BuilderModal
          bodyStyle={{ overflow: "inherit" }}
          isOpen={showOwnerModal}
          onClose={() => setShowOwnerModal(false)}
          modalName="Permissions"
        >
          <AccessTemplateSelection
            templates={applicationBlockData.access_templates}
            handleChange={handleAccessTemplate}
          />
        </BuilderModal>
      </div>
      <BuilderRightSideBar
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        heading="Edit recordsview"
        size="large"
      >
        <RecordsViewEditSection
          isMapBlock={isMapBlock}
          afterEffectOfFilter={afterEffectOfFilter}
          tableRef={tableRef}
          nonSelectedFilter={nonSelectedFilter}
          setNonSelectedFilter={setNonSelectedFilter}
        />
      </BuilderRightSideBar>
    </div>
  );
};

export default RecordDesktopRenderer;

const RenderMapPreview = ({ setIsEditOpen, isEditOpen }) => {
  return (
    <div className="Recordview_container">
      <div className={`Recordview_hover_container`}>
        {!isEditOpen && (
          <div className="edit_recordview_btn">
            <Button onClick={() => setIsEditOpen(!isEditOpen)}>Edit Mapsview</Button>
          </div>
        )}
        <MapPreview />
      </div>
    </div>
  );
};

const RenderTableView = ({ recordsviewLayout, setIsEditOpen, isEditOpen }) => {
  return (
    <>
      <div className="Recordview_container">
        <div className={`Recordview_hover_container`}>
          {!isEditOpen && (
            <div className="edit_recordview_btn">
              <Button onClick={() => setIsEditOpen(!isEditOpen)}>
                {recordsviewLayout.columns.length === 0 ? "Add Column" : "Edit Recordsview"}
              </Button>
            </div>
          )}
          <RecordviewDesktopPreview data={{ config: { layout: recordsviewLayout } }} />
        </div>
      </div>
    </>
  );
};

const RenderCatalogView = ({ recordsviewLayout, applicationBlockData }) => {
  return (
    <div className="detailsView_outer_wrap">
      <DesktopRenderer
        applicationBlockData={{
          data: {
            elements: recordsviewLayout?.catalog?.elements,
            table_id: recordsviewLayout.table_id
          },
          device: "desktop",
          id: applicationBlockData.id,
          name: applicationBlockData.name,
          table_type: applicationBlockData.table_type
        }}
        isForm={true}
      />
    </div>
  );
};
